'use strict';

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);
ngModule.controller("DemandeCreationFinanceurPopinController", function ($scope, $session, $applications) {
  $scope.appPath = $applications.getCurrentAppPath();
  $scope.telephoneFixe = $session.getUser().telephoneFixe;
  $scope.telephonePortable = $session.getUser().telephonePortable;
  $scope.hasTelephone = $scope.telephoneFixe != null || $scope.telephonePortable != null;
  $scope.emptyMessage = function () {
    // au moins 3 carac
    $scope.message == null || $scope.message.comment.length < 3;
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/ui/selectbox/configs/finaceursSubvention/demande-creation-financeur/demandeCreationFinanceurPopin.js
// module id = 2994
// module chunks = 13